function mouseEnter({ mobileView, dropdownMenu }) {
  if (mobileView()) return;

  // Hide any open dropdown menus before showing the new one
  document.querySelectorAll('.dropdown-menu').forEach((menu) => {
    menu.classList.add('lg:hidden');
  });

  dropdownMenu.classList.remove('lg:hidden');
}

function mouseLeave({ mobileView, dropdownMenu }) {
  if (mobileView()) return;

  dropdownMenu.classList.add('lg:hidden');
}

document.addEventListener('DOMContentLoaded', () => {
  let currentWidth = window.innerWidth;

  function mobileView() {
    return currentWidth < 1024;
  }

  visualViewport.addEventListener('resize', () => {
    currentWidth = window.innerWidth;
  });

  const dropdownButtons = document.querySelectorAll('.jnf-dropdown-btn');

  dropdownButtons.forEach((dropdownButton) => {
    const dropdownMenuWrapper = dropdownButton.nextElementSibling;
    const dropdownMenu = dropdownMenuWrapper.firstChild;

    dropdownButton.addEventListener('mouseenter', () =>
      mouseEnter({ mobileView, dropdownMenu }),
    );
    dropdownMenuWrapper.addEventListener('mouseleave', () =>
      mouseLeave({ mobileView, dropdownMenu }),
    );
  });

  // Clicking outside of an open dropdown menu closes it
  window.addEventListener('click', function (e) {
    if (mobileView()) return;

    if (!e.target.matches('.jnf-dropdown-btn')) {
      document.querySelectorAll('.jnf-dropdown-menu').forEach((menu) => {
        if (!menu.contains(e.target)) {
          menu.classList.add('lg:hidden');
        }
      });
    }
  });

  const mobileMenuButton = document.querySelector('.mobile-menu-button');
  const navMenu = document.querySelector('.navigation-menu');

  mobileMenuButton.addEventListener('click', () => {
    if (!mobileView()) return;

    navMenu.classList.toggle('hidden');
  });
});
